<template>
  <div :class="cssTheme" class="k-input-group">
    <label class="k-label">{{ label }}</label>

    <div v-if="readonly" class="show-readonly">{{ content }}</div>
    <textarea-autosize
      v-else
      :placeholder="placeholder"
      :style="getMaxHeight"
      :type="type"
      :id="id"
      v-model="content"
      :rows="row"
      :min-height="15"
      :class="textareaCustomClass"
      :maxlength="maxLength"
      @input="handleInput"
      @focus.native="$event.target.select()"
    />
    <span class="text-danger" v-if="error">
      {{ error }}
    </span>
  </div>
</template>

<script>
import { constants } from '@/shared/constant';
export default {
  props: {
    value: {
      required: true,
    },
    id: {
      required: false,
    },
    label: {
      type: String,
      required: false,
    },

    type: {
      type: String,
      required: false,
      default: 'text',
    },

    placeholder: {
      type: String,
      required: false,
      default: null,
    },

    darkMode: {
      type: Boolean,
      required: false,
      default: false,
    },

    readonly: {
      type: Boolean,
      default: false,
    },

    error: {
      type: String,
      required: false,
      default: null,
    },
    row: {
      default: 1,
    },
    textareaCustomClass: {
      type: String,
      required: false,
      default: null,
    },
    maxLength: {
      type: Number,
      required: false,
      default: constants.textAreaMaxCharacterLimit,
    },
  },

  data() {
    return {
      content: this.value,
    };
  },

  watch: {
    value: function (newVal, oldVal) {
      console.info('Prop value changed: ', newVal, ' | was: ', oldVal);
      if( this.content != newVal ) this.content = newVal;
    },
  },

  computed: {
    // cssTheme() {
    //   if (this.darkMode) {
    //     return 'dark';
    //   }
    //   return 'light';
    // },

    cssTheme() {
      if (this.darkMode) return 'text-dark-mode';
      return 'text-light_mode';
    },

    getMaxHeight() {
      let maxValue = '';
      if (this.row == 1) {
        maxValue = 'max-height: ' + constants.textAreaMaxHeight + 'px';
      } else if (this.row == 10) {
        let length = 1;
        if (this.content) {
          length = this.content.split('\n').length;
          length = length <= this.row ? length : this.row;
        }
        // console.log('length -->', length);
        maxValue = 'max-height: ' + length * 23 + 'px';
      }
      return maxValue;
    },
  },
  methods: {
    handleInput() {
      this.$emit('input', this.content);
    },

    clearInput() {
      this.content = '';
    },
  },
};
</script>

<style lang="scss">
@import '@/styles/components/input-text.scss';

label.k-label {
  margin-bottom: 0;
}

textarea {
  padding: 0px;
}

.text-dark-mode > textarea {
  color: white !important;
}
</style>
